module.exports = __webpack_public_path__ + "img/DS6206X8.fdf78ad4.jpg";